/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createRecord.defs'
export { main as default } from './createRecord.defs'
